export default __webpack_public_path__ + "static/termsAndConditionsClip-2d0e0ecfad07b5cb9477134ab5a72195.png";